import React from 'react';
import Icon from "./Icon";

const IconBeach = ({tooltip}) => {
    return (
        <Icon image="/img/icons/icon-beach.svg" tooltip={tooltip}/>
    )
};

export default IconBeach;